// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const ToolbarConfig = () => (function(config: any) {
   const t = config.toolbar

   return {
      excludeNews: t.refine_search_selection?.includes('exclude_newspaper_articles'),
      fullTextOnline: t.refine_search_selection?.includes('full_text_online'),
      institutionCatalog: t.refine_search_selection?.includes('items_at_my_institution'),
      libraryCatalog: t.refine_search_selection?.includes('items_in_catalog'),
      limitToPeerReviewed: t.refine_search_selection?.includes('limit_to_peer_reviewed'),
      limitToScholarly: t.refine_search_selection?.includes('limit_to_scholarly'),
      includeMatchesFullTextOverride: t.refine_search_selection?.includes('include_matches_full_text_override'),
      includeMatchesFullTextDefault: t.include_matches_full_text_default
   }
})


angular.module('summonApp.factories.configs')
   .factory('toolbarConfig', ToolbarConfig)
